import { FulfillmentGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";

export const getFulfillmentGroupsByOrderId = {
  name: "getFulfillmentGroupsByOrderId" as const,
  input: z.object({ externalOrderId: z.string() }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupSchema) }),
};
